let BASE_URL = ''    
let BASE_URL_TWO = ''
let UNAUDIT_ORDERS_URL='';
let GET_ORDERS_PRINTED=''
let TEST_URL = 'https://erp.shopsbu.com/crm';
let TEST_URL2 = 'https://erp.shopsbu.com/cus';
let TEST_URL3 = 'https://erp.shopsbu.com/sales/chat';
let TEST_URL4 = 'https://erp.shopsbu.com/service';
let USERINFO = 'http://47.57.9.89:8101';
const WEANALY_DOMAIN  ='https://www.weanaly.com/chrome-extension';


 
 let url=location.href
 console.log(url)
 if(url.indexOf('dianxiaosheng') > -1 || url.indexOf('shopsooo.com') > -1) {//普通用户
 	BASE_URL = 'https://erp.shopsbu.com/service'
	 GET_ORDERS_PRINTED = 'https://erp.shopsbu.com/query_data'	
	TEST_URL='https://erp.shopsbu.com/crm'
 	BASE_URL_TWO = 'https://erp.shopsbu.com/query_data'
	UNAUDIT_ORDERS_URL='https://erp.shopsbu.com/query_data/order/getUnAuditOrders'
	TEST_URL3 = 'https://erp.shopsbu.com/sales/chat';
	let TEST_URL4 = 'https://erp.shopsbu.com/service';
	USERINFO = 'https://erp.shopsbu.com/service';
 }else if(url.indexOf('weanaly') > -1){//印尼用户跳转
 	BASE_URL = 'https://erp.weanaly.com/service'
	GET_ORDERS_PRINTED = 'https://erp.weanaly.com/query_data'	
	TEST_URL='https://erp.weanaly.com/crm'
 	BASE_URL_TWO = 'https://erp.weanaly.com/query_data'
	UNAUDIT_ORDERS_URL='https://erp.shopsbu.com/query_data/order/getUnAuditOrders'
	TEST_URL3 = 'https://erp.shopsbu.com/sales/chat';
	let TEST_URL4 = 'https://erp.shopsbu.com/service';
	USERINFO = 'http://47.57.9.89:8101';
 }else if(url.indexOf('shopsbu') > -1){//印尼用户跳转
 	BASE_URL ='https://erp.shopsbu.com/service'
	GET_ORDERS_PRINTED = 'https://erp.shopsbu.com/query_data'	
	TEST_URL='https://erp.shopsbu.com/crm'
 	BASE_URL_TWO ='https://erp.shopsbu.com/query_data'
	UNAUDIT_ORDERS_URL='https://erp.shopsbu.com/query_data/order/getUnAuditOrders'
	TEST_URL3 = 'https://erp.shopsbu.com/sales/chat';
	let TEST_URL4 = 'https://erp.shopsbu.com/service';
	USERINFO = 'https://erp.shopsbu.com/service';
 }else if(url.indexOf('192.168.1.2') > -1){
	BASE_URL ='http://52.202.1.94:8085'
	GET_ORDERS_PRINTED = 'http://52.202.1.94:8085/query_data'	
	TEST_URL='http://52.202.1.94:8085/crm'
 	BASE_URL_TWO ='http://52.202.1.94:8085/query_data'
	UNAUDIT_ORDERS_URL='https://erp.shopsbu.com/query_data/order/getUnAuditOrders'
	TEST_URL3 = 'https://erp.shopsbu.com/sales/chat';
	let TEST_URL4 = 'https://erp.shopsbu.com/service';
	USERINFO = 'http://52.202.1.94:8085/service';
 }
 else if(url.indexOf('192.168.31.10') > -1){
	BASE_URL ='http://192.168.31.154:8082'
	GET_ORDERS_PRINTED = 'http://192.168.31.154:8082/query_data'	
	TEST_URL='http://192.168.31.154:8082/crm'
 	BASE_URL_TWO ='http://192.168.31.154:8082/query_data'
	UNAUDIT_ORDERS_URL='https://erp.shopsbu.com/query_data/order/getUnAuditOrders'
	TEST_URL3 = 'https://erp.shopsbu.com/sales/chat';
	let TEST_URL4 = 'https://erp.shopsbu.com/service';
	USERINFO = 'http://192.168.31.154:8082/service';
 }else if(url.indexOf('localhost:8080') > -1){
	BASE_URL ='/api/service'
	GET_ORDERS_PRINTED = '/api/query_data'	
	TEST_URL='/api/crm'
 	BASE_URL_TWO ='/api/query_data'
	UNAUDIT_ORDERS_URL='https://erp.shopsbu.com/query_data/order/getUnAuditOrders'
	TEST_URL3 = 'https://erp.shopsbu.com/sales/chat';
	let TEST_URL4 = 'https://erp.shopsbu.com/service';
	USERINFO = '/api/service';
 }
//  else if(url.indexOf('192.168.31.32') > -1){
// 	BASE_URL ='https://erp.shopsbu.com:8082'
// 	GET_ORDERS_PRINTED = 'https://erp.shopsbu.com:8082/query_data'	
// 	TEST_URL='https://erp.shopsbu.com:8082/crm'
//  	BASE_URL_TWO ='https://erp.shopsbu.com:8082/query_data'
// 	UNAUDIT_ORDERS_URL='https://erp.shopsbu.com/query_data/order/getUnAuditOrders'
// 	TEST_URL3 = 'https://erp.shopsbu.com/sales/chat';
// 	let TEST_URL4 = 'https://erp.shopsbu.com/service';
// 	USERINFO = 'https://erp.shopsbu.com:8082/service';
//  }
 else{
	BASE_URL = 'https://erp.shopsbu.com/service'	
	GET_ORDERS_PRINTED = 'http://47.57.9.89:8086'
 	BASE_URL_TWO = 'https://erp.weanaly.com/query_data'
 	UNAUDIT_ORDERS_URL='https://erp.shopsbu.com/query_data/order/getUnAuditOrders'
	TEST_URL='https://erp.shopsbu.com/crm'
	TEST_URL3 = 'https://erp.shopsbu.com/sales/chat';
	let TEST_URL4 = 'https://erp.shopsbu.com/service';
	USERINFO = 'https://erp.shopsbu.com/service';
	
 }
//  暂时修改
//  let ApiUrl = '/jxsApi'

// BASE_URL = ApiUrl + '/service'
// GET_ORDERS_PRINTED = ApiUrl + '/query_data'
// TEST_URL = ApiUrl + '/crm'
// BASE_URL_TWO = ApiUrl + '/query_data'
// UNAUDIT_ORDERS_URL = ApiUrl + '/query_data/order/getUnAuditOrders'
// TEST_URL2 = ApiUrl + '/cus';
// TEST_URL3 = ApiUrl + '/sales/chat';
// TEST_URL4 = ApiUrl + '/service';
// USERINFO = ApiUrl + '/service';

 const publishLazada={
	GET_LAZADA_CATEGORY:`${BASE_URL}/item/lazada/category/get`,//获取Lazada类目
	GET_LAZADA_CATEGORY_ATTRIBUTE:`${BASE_URL}/item/lazada/category/attribute/get`,//获取Lazada类目属性
	UPDATE_LAZADA_PRODUCT:`${BASE_URL}/item/updateLazadaProduct`,//增加/修改Lazada商品模板
	GET_LAZADAMODE_BYID:`${BASE_URL}/item/getLazadaProduct`,//根据商品PRODUCTID获取Lazada商品详情
	PUBLISH_LAZADA_PRODUCT:`${BASE_URL}/item/publish/lazada/product`,//发布Lazada商品
	GET_LAZADA_IMG:`${BASE_URL}/item/image/migrate`,//将图片转为lazada地址


 }

 const storeAffi={
	 STORE_AFFAIRS_CREATE:`${BASE_URL}/task/create`,//卖家创建事务
	 STORE_AFFAIRS_DELETE:`${BASE_URL}/task/delete`,//卖家删除事务
	 STORE_AFFAIRS_CANCELCONFIRM:`${BASE_URL}/task/cancelConfirm`,//卖家退回仓库确认
	 STORE_AFFAIRS_SELLERCONFIRM:`${BASE_URL}/task/seller/confirm`,//卖家确认任务完成,结算费用
	 STORE_AFFAIRS_EXTRACONFIRM:`${BASE_URL}/task/seller/extra/confirm`,//卖家确认额外费用
	 STORE_AFFAIRS_TYPE_GET:`${BASE_URL}/task/type/get`,//卖家根据国家获取任务类型
	 STORE_AFFAIRS_RECEIPT:`${BASE_URL}/task/receipt`,//仓库接收卖家任务
	 STORE_AFFAIRS_REFUSE:`${BASE_URL}/task/refuse`,//仓库拒接卖家任务
	 STORE_AFFAIRS_STORE_COMFIRM:`${BASE_URL}/task/store/confirm`,//仓库确认处理进度
	 STORE_AFFAIRS_STREO_EXTRA:`${BASE_URL}/task/store/extra`,//仓库修改额外费用
	 STORE_AFFAIRS_TASKGET:`${BASE_URL}/task/get`,//获取用户事务
	 STORE_AFFAIRS_SEND:`${BASE_URL}/task/send`,//更新卖家与仓库关于任务进行情况
	BIND_VARTRAL_SKU:`${BASE_URL}/bindItem/bind/virtual/sku`,
	TIKTOK_CATEGORY_TRANSFER:`${BASE_URL}/item/tts/categories/translate`,
	GROUP_CODE:`${BASE_URL}/platform/group/code`,
	DISCOUNT:`${BASE_URL}/platform/discount/distributionCommission`,
	
 }

 const transfer={
	 GET_transfer_add:`${BASE_URL}/store/transfer/add`,//仓库创建转仓单
	 GET_transfer_get:`${BASE_URL}/store/transfer/get`,//获取转仓单
	 GET_transfer_choose:`${BASE_URL}/store/transfer/choose`,//卖家选择转仓单要转入的新仓
	 GET_transfer_OLDGOODS:`${BASE_URL}/store/transfer/check/old`,//老仓核对库存产品数量并转移系统的库存产品给新仓
	 GET_transfer_NEWGOODS:`${BASE_URL}/store/transfer/check/new`,//新仓核对库存产品数量并上架
	 GET_transfer_DELETE:`${BASE_URL}/store/transfer/delete`,//新仓核对库存产品数量并上架
	 CURRENCYALL:`${BASE_URL}/statistics/currency/get/all`,//获取当前所有国家的汇率
	 CURRENCYUPDATE:`${BASE_URL}/statistics/currency/update`,//更新或插入汇率
	 GETSTORESTA:`${BASE_URL}/statistics/store/get`,//获取库存概况
	 GETSHOPSH:`${BASE_URL}/statistics/shop/get`,//获取商店的销售情况
	 GETINTEGRAL:`${BASE_URL}/statistics/integral/get`,//获取积分收入支出概况
	 UPDATA_ONLINE_ITEM:`${BASE_URL}/item/updateItemOnline`,
	 GET_PRICE_CLEAN:`${BASE_URL}/platform/clear/price/get`,
	 GET_PUBLISH_STORE:`${BASE_URL}/store/published/get`,

	
 }



 const account={
	ADD_BUYER:`${BASE_URL}/access/addBuyer`,
	GET_BUYER:`${BASE_URL}/access/getBuyers`,
	BUYER_UPDATECOST:`${BASE_URL}/item/buyerUpdateCost`,
	GET_SHOPACCESS:`${BASE_URL}/access/getShopAddress`,
	RELEVANCE_WEANALYUSER:`${BASE_URL}/access/relevanceWeanalyUser`,
	GET_ACCONT_DXS:`${BASE_URL}/access/getUserByWeanalyUser`,
	PUBLISH_TO_DXS:`${BASE_URL}/item/publishProductToDXS`,
	GET_DXS_PRODUCT:`${BASE_URL}/item/getDXSProduct`,
	PLACE_DXS_ORDER:`${BASE_URL}/shopOrder/placeDxsOrder`,
	GET_OLIONE_PRODUCT:`${BASE_URL}/item/get`,
	INIT_STORE_ITEM:`${BASE_URL}/item/initStoreItem`,
	GET_IMPORT_DETAIL:`${BASE_URL}/item/initStoreItem/get`,
	GET_IMPORT_ERROR_DETAIL:`${BASE_URL}/item/initStoreItemError/get`,
	SELLER_UPDATA_STOREITEM:`${BASE_URL}/item/sellerUpdateStoreItemDetail`,
	UPDATE_DEFAULT_ACTIVITY_PRICE:`${BASE_URL}/item/updateDefaultActivityPrice`,
	SET_AUTO_ACTIVITY:`${BASE_URL}/item/setAutoActivity`,
	GET_MARKETING_ACTIVITY_LIST:`${BASE_URL}/item/getMarketingActivityList`,
	UPLOAD_WATERIMG:`${BASE_URL}/access/addWatermark`,
	GET_WATERIMG:`${BASE_URL}/access/select/watermark`,
	DELETE_WATERIMG:`${BASE_URL}/access/delete/watermark`,
	DOWNLOAD_MODEL_EXCEL:`${BASE_URL}/shopOrder/downloadDxsOrderExcelFile`,
	REFRESH_INTEGRAL:`${BASE_URL}/integration/refreshIntegral`,
	BIND_STORE_RETURN:`${BASE_URL}/shopOrder/bindStoreReturn`,
	GET_NOWRULES_INTEGRAL:`http://192.168.1.41:8085/integration/refreshIntegral/get`,//获取在现在规则下卖家的收费
	
 }


 const group={
	 GET_USER_GROUP:`${BASE_URL}/statistics/getUserGroup`,//获取用户小组
	 CREATE_GRUOP:`${BASE_URL}/statistics/createShopGroup`,//创建小组
	 DELETE_GRUOP:`${BASE_URL}/statistics/deleteGroup`,//删除小组
	 BIND_SHOP_GRUOP:`${BASE_URL}/statistics/bindShopGroup`,//绑定小组
	 DELETE_SHOP_GROUP:`${BASE_URL}/statistics/deleteShopGroup`,//删除绑定
	 UPDATE_GRUOP:`${BASE_URL}/statistics/updateGroup`,//更新小组
	 UPDATE_GRUOP_COST:`${BASE_URL}/statistics/updateGroupCost`,//更新小组费用项
	 INSET_GRUOP_COST:`${BASE_URL}/statistics/insertGroupCost`,//插入费用项
	 DELETE_GRUOP_COST:`${BASE_URL}/statistics/deleteGroupCost`,//删除费用项
	 GET_HISTORY_COST_NAME:`${BASE_URL}/statistics/getHistoryCostName`,//获取历史费用项
	 UPDATE_GROUP_INFO:`${BASE_URL}/statistics/updateGroup`,//更新小组
	 UPDATA_AUTO_RESERVED:`${BASE_URL}/item/updateAutoReserved`,
	 UPDATA_RESERVED_STOCK:`${BASE_URL}/item/updateReservedStock`,
	 GET_USER_CATEgory:`${TEST_URL}/portrait/category`,// 获取用户画像分类
	 CATEGORY_BUYER_USER:`${TEST_URL}/portrait/category/buyerUser`,// 获取某个用户某个分类的所有买家
	 BUYSER_ORDERS:`${TEST_URL}/portrait/buyerUser/orders`,//
	 GET_STOREITEM_BY_GROUP:`${BASE_URL}/item/getStoreItemByGroup`,
	 UPDATA_STORE_USED:`${BASE_URL}/access/updateStoreUsed`,
	 GET_PRODUCT_BY_ID:`${BASE_URL}/item/getProductByIds`,
	 GET_CATEGORY_BY_SHOPS:`${BASE_URL}/item/getCategoryByShops`,
	 GET_SHOP_LOGISTICS:`${BASE_URL}/item/getAttributesAndLogistics`,
	 GET_ORDERS_BY_ORDERID:`${GET_ORDERS_PRINTED}/order/getOrderByOrderIds`,
	 GET_ORDERS_BY_ORDERID_LAZAD:`${GET_ORDERS_PRINTED}/lazada/getOrderByOrderIds`,
	 SCRAPE_DATA:`${BASE_URL}/item/getItemDetail`,
	 GET_STOREITEM_BY_GROUPID:`${BASE_URL}/item/getStoreItemByGroupId`,
	 UPDATE_LIMITAGENCYNUM:`${BASE_URL}/platform/update/limitAgencyNum`,
	 GET_SHOPEEPARNET_SHOP:`${BASE_URL}/access/getShopeeUrl`,
	 

 }
//重新整理订单的接口
 const queryOrders={
	QUER_PENDING_ORDERS:`${BASE_URL}/query/queryPendingOrders`,
	GET_ORDER_BILL_URL:`${BASE_URL}/shopOrder/getOrderBillUrl`,
	GET_ORDERS_PDF:`${BASE_URL}/shopOrder/getOrdersPdf`,
	SHOPORDER_START_READY_ORDERS:`${BASE_URL}/shopOrder/startReadyOrders`,
	SHOPOEDER_NEW_ORDERS:`${BASE_URL}/shopOrder/getNewOrders`,
	SHOPOEDER_SETORDER_FALG:`${BASE_URL}/shopOrder/setOrderFlag`,
	SHOPOEDER_CANCEL_AUDITED_ORDERS:`${BASE_URL}/shopOrder/cancelAuditedOrders`,
	PROCESSED_ORDERS_LOGISTICS:`${BASE_URL}/store/getLogistics`,
	SHOPOEDER_QUERYPACKAGED_ORDERS:`${BASE_URL}/store/queryPackagedOrders`,
	SHOPOEDER_QUERYPACKAGED_ORDERS_NUM:`${BASE_URL}/store/queryPackagedOrdersNum`,
	SHOPOEDER_UPDATE_PACKAGED_TRACKING_WARNING_LABEL:`${BASE_URL}/store/updatePackagedTrackingWarningLabel`,
	SHOPOEDER_SET_PACKAGED:`${BASE_URL}/shopOrder/setPackaged`,
	SHOPOEDER_ADDPRINTNUM:`${BASE_URL}/shopOrder/addPrintNum`,
	SHOPOEDER_UPDATE_ORIGINAL:`${BASE_URL}/shopOrder/updateOriginal`,
	SHOPOEDER_GETORDER_BYSTYORE:`${BASE_URL}/shopOrder/getOrderByStore`,//仓库获取扫描订单
	SHOPOEDER_UPDATE_CHECKTIME:`${BASE_URL}/shopOrder/updateCheckTime`,//仓库记录订单扫描核对时间
	SHOPOEDER_MASS_GETSTROEITEM_BYCUSCODE:`${BASE_URL}/item/getItemByItemKey`,//批量用cusCode查找母仓库产品
	SHOPOEDER_UPDATE_EMPTY_ORDER:`${BASE_URL}/shopOrder/updateEmptyOrder`,//一键修改为空包
	SHOPOEDER_COMPLAIN_APPLY:`${BASE_URL}/shopOrder/complain/apply`,//卖家申诉仓库退回处理费 
	SHOPOEDER_COMPLAIN_GET:`${BASE_URL}/shopOrder/complain/get`,//卖家申诉仓库退回处理费 
	SHOPOEDER_STORE_DISPOST:`${BASE_URL}/shopOrder/complain/storeDispose`,//仓库处理，不同意complete=false，并传fee为仓库愿意赔付的积分，同意complete=true
	SHOPOEDER_INSERT_PRINT_HISTORY:`${BASE_URL}/print/insertPrintHistory`,
	SHOPOEDER_COPY_STYOREITEM_BYSTORE:`${BASE_URL}/item/copyStoreItemByStore`,
	SHOPOEDER_GET_PRINT_HISTORY:`${BASE_URL}/print/getPrintHistory`,
	SHOPOEDER_CREATE_DIANXIAOSHEN_ORDER:`${BASE_URL}/shopOrder/createDxsOrder`,
	SHOPOEDER_TRANSFORM_STORE_ITEM_SELLER:`${BASE_URL}/store/transferSellerStoreItem`,
	SHOPOEDER_GET_SELLERITEM_STOREITEM_DATA:`${BASE_URL}/store/getSellerStoreItemData`,
	SHOPOEDER_GET_STORE_ALLBYTYPE:`${BASE_URL}/store/getStoreAllByType`,
	SHOPOEDER_RETURN_PURCHASEoRDER:`${BASE_URL}/purchaseOrder/returnPurchaseOrder`,
	SHOPOEDER_DELETE_DXSORDER:`${BASE_URL}/shopOrder/deleteDxsOrder`,
	SHOPOEDER_GET_LOGISTICS_RULEBY_STORE:`${BASE_URL}/integration/getLogisticsRuleByStore`,
	SHOPOEDER_CREATE_DXSLOGISTICS_ORDER:`${BASE_URL}/shopOrder/createDxsLogisticsOrder`,
	SHOPOEDER_CREATE_DISTRIBUTION_STORE:`${BASE_URL}/store/addDistributionStore`,
	SHOPOEDER_GET_DISTRIBUTION_STORE:`${BASE_URL}/store/getPrivateStoreAccount`,
	SHOPOEDER_ADD_PRIVATE_STORE:`${BASE_URL}/store/sellerAddPrivateStore`,
	SHOPOEDER_GET_ORDER_TIME:`${BASE_URL}/print/getOrderTime`,
	SHOPOEDER_SELLER_REMIND:`${BASE_URL}/shopOrder/remind/sellerRemind`,
	SHOPOEDER_UPDATE_USER_ATTRIBUTE:`${BASE_URL}/access/updateUserAttribute`,//存储一下用户的信息
	SHOPOEDER_GET_USER_ATTRIBUTE:`${BASE_URL}/access/getUserAttribute`,//存储一下用户的信息
	SHOPOEDER_QUERY_RETURN_ORDERS:`${BASE_URL}/query/queryRemindOrders`,//获取催单
	SHOPOEDER_QUERY_REMIND_NUM:`${BASE_URL}/query/queryRemindNum`,//获取需要处理的订单信息数量
	SHOPOEDER_GET_USERINVITECODE:`${BASE_URL}/access/getUserInviteCode`,//获取用户的邀请码
	SHOPOEDER_JOIN_DISTRIBUTION:`${BASE_URL}/access/getUserInviteCodeByDistribution`,//参加分销活动	
	SHOPOEDER_GET_DISTRIBUTION:`${BASE_URL}/access/discount/getDistribution`,//获取分销活动	
	SHOPOEDER_GET_PHONE_PASSWORD:`${BASE_URL}/access/getPhoneCodeByUpdatePassword`,//获取手机验证码
	SHOPOEDER_GET_PHONE:`${BASE_URL}/access/getPhoneCode`,//获取手机验证码
	SHOPOEDER_GET_PHONE_REGISTORE:`${BASE_URL}/access/phoneRegister`,//获取手机验证码
	SHOPOEDER_GET_USER_INVITEE:`${BASE_URL}/access/getUserInvitee`,//获取用户所邀请的人
	SHOPOEDER_QUETY_LOGISTICS_ORDER:`${BASE_URL}/query/queryLogisticsOrder`,
	SHOPOEDER_UPDATE_SHOP_REMARK:`${BASE_URL}/access/updateShopRemark`,//更新商店备注名
	SHOPOEDER_GETDISTRIBUTION_STOREITEMS:`${BASE_URL}/item/getDistributionStoreItems`,//获取已分销的产品
	SHOPOEDER_GETUSER_INFO_INVITATIONCODE:`${BASE_URL}/access/getUserInviteeByCode`,
	SHOPOEDER_BIND_BYITEMKEY:`${BASE_URL}/bindItem/bindByItemKey`,//根据itemKey绑定或修改绑定
	SHOPOEDER_CHECK_INVENTORY:`${BASE_URL}/item/checkInventory`,//仓库批量盘点库存数量
	SHOPOEDER_SET_USERCACHE:`${BASE_URL}/access/insertUserCache`,//插入或更新用户缓存数据
	SHOPOEDER_GET_USERCACHE:`${BASE_URL}/access/getUserCache`,
	SHOPOEDER_PROXYHTTPS:`${BASE_URL}/chat/proxyHttps`,
	SHOPOEDER_UPDATEUSER_AUDITLIMIT:`${BASE_URL}/access/updateUserAuditLimit`,
	SHOPOEDER_GETUSER_AUDITLIMIT:`${BASE_URL}/access/getUserAuditLimit`,
	SHOPOEDER_GET_ADDRESS_CODE:`${BASE_URL}/shopOrder/getOrderLogistic`,
	SHOPOEDER_ALERT_RETURN:`${BASE_URL}/query/alterReturnOrders`,
	INTEGRAL_DEDUCT:`${BASE_URL}/integration/manual/partner/integral/deduct`,
	UPLOAD_IMG_TOSHOPEE:`${BASE_URL}/access/image/upload/shopee`,
	CREATE_DXS_ORDER_EXCEL:`${BASE_URL}/shopOrder/createDxsOrderExcel`,
	
	SHOPOEDER_UPDATESHOPORDERSBYID:`${BASE_URL}/shopOrder/updateShopOrdersById`, //根据订单号同步订单

	
	SHOPOEDER_BATCHDOWNLOADPRINTDRAWINGS:`${BASE_URL}/shopOrder/batchDownloadPrintDrawings`,  //批量下载打印图
	SHOPOEDER_SCANOUTBOUND:`${BASE_URL}/shopOrder/scanOutbound`,  //扫描出库
	
	
 }
 

 const distribution={
	 DISTRIBUTION:`${BASE_URL}/platform/putAway`,
	 SOLDOUT_PRODUCT:`${BASE_URL}/platform/soldOut`,//母sku整体下架
	 OUT_SHELFT:`${BASE_URL}/platform/storeItem/soldOut`,
	 PUT_AWAY:`${BASE_URL}/platform/storeItem/putAway`,
	 UPDATAPRICE:`${BASE_URL}/platform/storeItem/update/price`,

 }
 



const processed={
	GET_PROCESSED_ORDERSN_INFO:`${BASE_URL}/shopOrder/getDetailOrderInfos`,
	GET_ID_ACCOUNT_PROCESS_LIST:`${BASE_URL}/print/getPackagedOrders`,
	GET_PROCESSED_ORDERSN:`${BASE_URL}/shopOrder/getOrdersByOrdersn`,
	GET_PACKED_ORDER_BY_STORE:`https://erp.weanaly.com/erp/feign/print/getPackagedOrdersByStore`,
	
	//shopee
	GET_PROCESSED_ORDERS_PARAMS:`${BASE_URL}/store/queryPackagedOrdersNum`,//卖家获取一段时间内打包的订单数量
	GET_PROCESSED_ORDERS_PARAMS_STORE:`${BASE_URL_TWO}/order/getPackagedOrderAmountByStore`,//仓库获取一段时间内打包的订单数量
	GET_LOGISTICS:`${GET_ORDERS_PRINTED}/order/getLogistics`,//获取卖家的物流方式 
	GET_LOGISTICS_STORE:`${BASE_URL_TWO}/order/getLogisticsByStore`,//获取仓库的物流方式
	GET_SELLER_PROCESSED_ORDER:`${BASE_URL}/store/queryPackagedOrders`,//获取卖家所有的忆处理订单
	GET_STORE_PROCESSED_ORDER:`${BASE_URL_TWO}/order/getPackagedOrderByStore`,//获取仓库所有的已处理订单
	GET_ORDER_BY_ORDERID:`${BASE_URL_TWO}/order/getOrderByOrderId`,//获取已出库的订单信息
	MASS_DELITE_SOTORE_ITEM_ALL:`${BASE_URL}/item/deleteStoreItemAll`,
	UPDATE_COMPONENT:`${BASE_URL}/item/updateComponent`,
	GET_CORRELATION_DATA:`${BASE_URL}/item/getCorrelation`,
	BATCH_TRANSFET_STOREITEM:`${BASE_URL}/item/batchTransferStoreNum`,
	
	
	//lazada
	GET_LOGISTICS_LAZADA:`${BASE_URL_TWO}/lazada/getLogistics`,//LAZADA获取卖家的物流方式 
	CANCEL_AUDITED_LAZADA_ORDER:`${BASE_URL}/shopOrder/lazada/cancelAuditedLazadaOrders`,


	//暂时修改

	GET_PROCESSED_ORDERS_PARAMS_LAZADA:`${BASE_URL}/store/queryPackagedOrdersNum`,//LAZADA卖家获取一段时间内打包的订单数量
	GET_SELLER_PROCESSED_ORDER_LAZADA:`${BASE_URL}/store/queryPackagedOrders`,//LAZADA获取卖家所有的忆处理订单
	GET_STORE_PROCESSED_ORDER_LAZADA:`${BASE_URL}/store/queryPackagedOrders`,//lazada获取仓库所有的已处理订单



	GET_ORDERS_BY_STORE:`${BASE_URL_TWO}/lazada/getOrdersByStore`,//获取仓库所有的待处理订单
	
	GET_PROCESSED_ORDERS_PARAMS_STORE_LAZADA:`${BASE_URL_TWO}/lazada/getPackagedOrderAmountByStore`,//lazada仓库获取一段时间内打包的订单数量
	GET_LOGISTICS_STORE_LAZADA:`${BASE_URL_TWO}/lazada/getLogisticsByStore`,//lazada获取仓库的物流方式
	GET_STORE_PROCESSED_ORDER_LAZADA:`${BASE_URL_TWO}/lazada/getPackagedOrderByStore`,//lazada获取仓库所有的已处理订单
}

const productModel={
	DELETE_PRODUCT_MODEL:`${BASE_URL}/item/deleteProduct`,//删除母模版下面子模版
	DELETE_PRODUCT_MODEL_ALL:`${BASE_URL}/item/deleteProductModel`,//整个删除母模版
	GET_ATTRIBUTES_BY_COUNTRY:`${BASE_URL}/item/getAttributes`,
	ADD_PRODUCT_MODEL:`${BASE_URL}/item/updateProduct`,//增加/修改商品模板
	UPDATE_PRODUCT_MODEL:`${BASE_URL}/item/updateProductModel`,//增加/修改用户商品模板名
	PUBLISH_PRODUCT:`${BASE_URL}/item/publishProduct`,//上架商品
	GET_USER_PRODUCT_MODELS:`${BASE_URL}/item/getUserProductModels`,//获取用户模板基本信息 
	GET_USER_PRODUCT_MODELS_BYID:`${BASE_URL}/item/getUserProductModel`,//根据ID获取用户单个商品模板的详细信息
	GET_ITEM_ATTRIBUTE:`${BASE_URL}/item/getItemAttribute`,
	GET_CATEGORY_COUNTRY:`${BASE_URL}/item/getCategoryByCountry`,
	PUBLISH_PRODUCT:`${BASE_URL}/item/publishProduct`,

}

const login= {
	ADD_SHOP: `${BASE_URL}/shop/addShop `,
	GET_SHOP_INFO: `${BASE_URL}/shop/getShopInfo`,
	GET_SHOP_ALL_INFO: `${BASE_URL}/shop/getShops`,
	GET_LOGIN_IN:`${BASE_URL}/access/login`,
	GEI_LOCK_SHOP_ID:`${BASE_URL}/access/bindShop`,
	GET_SHOPS:`${BASE_URL}/access/getShops`,
	GET_EMAIL_CODE:`${BASE_URL}/access/getEmailCode`,
	USER_ID_REGISTER:`${BASE_URL}/access/userIDRegister`,
	REGISTER:`${BASE_URL}/access/register`,
	GET_EMAIL_CODE_BY_CHANGEPWS:`${BASE_URL}/access/getEmailCodeByChangePassword`,
	CNAGE_PWS:`${BASE_URL}/access/changePassword`,


}

const shopaccess={
	GET_ALLSTORE_IN_STOREUSER:`${BASE_URL}/access/getStore`, //获取仓库帐号下所有的仓库
	GET_ALLSTORE_IN_SYSTEM:`${BASE_URL}/access/getVisualStores`, //获取系统内所有的仓库
	BIND_STORE_BY_SELLER:`${BASE_URL}/access/bindStore`, //卖家帐号绑定仓库
	SHOP_AUTHORIZATION:`${BASE_URL}/access/getAuthorizationUrl`, //店铺授权
	UNBOUND_SHOP:`${BASE_URL}/access/deleteUserShop`, //解绑商店
	UNBOUND_STORE:`${BASE_URL}/access/unboundStore`, //解绑仓库
	GET_LAZADA_AUTHORIZATION_INFO:`${BASE_URL}/access/getLazadaAuthorizationUrl`, //获取LAZADA授权网址
	GET_LAZADA_SHOP:`${BASE_URL}/access/lazada/getShops`, //获取已经绑定的lazada商店
	DELE_STORE:`${BASE_URL}/access/deleteStore`, //删除仓库
	GET_SHOP_SALES:`${BASE_URL}/sales/getShopSales`, //获取商店的销售情况 
	GET_CARGOVALUE_STORE:`${BASE_URL}/sales/getStoreCargoValue`, //获取仓库货值
	GET_SEARCH_USER_STORE:`${BASE_URL}/access/searchUserStore`, //获取当前帐号下的所有仓库
	GET_RETURN_ORDER:`${BASE_URL}/shopOrder/getReturnOrder`, //获取商店可以索赔的订单
	AUDIT_RETURN:`${BASE_URL}/shopOrder/auditReturnAll`, //确认索赔
	GIVE_UP_CLAIM:`${BASE_URL}/shopOrder/unReturnOrderAll`, //放弃索赔
	VERIFY_SECONDARYT_PASSWORD:`${BASE_URL}/access/verifySecondaryPassword`,//验证用户二次密码
	RESET_SECONDARYT_PASSWORD:`${BASE_URL}/access/resetSecondaryPassword`,//修改用户二级密码
	PRIVATE_STORE_REGISTER:`${BASE_URL}/store/createPrivateStore`,//新建私有仓帐号
    GET_SELLER_PRIVATESTORE:`${BASE_URL}/access/getSellerPrivateStore`,//获取卖家帐号的私有仓
	GET_CHARGE_ORDER:`${BASE_URL}/audit/getChargeOrder`,//仓库查看扣费的订单情况
	UPLOAD_IMG:`https://erp.shopsbu.com/service/access/upload`,
	UPLOAD_FILE:`https://erp.shopsbu.com/service/access/upload/file`,
	GET_INTEGRA_LOG:`${BASE_URL}/integration/getIntegralLog`,
	OPEN_SECNOND_PWS:`${BASE_URL}/access/usedSecPw`,//开启二次密码
	GET_USER_INFO:`${BASE_URL}/access/getUserInfo`,//获取用户信息
	BAND_SELLERID_AND_SHORID:`${BASE_URL}/access/bindShop`,//将卖家账号与已授权商店强制绑定
	CHECK_EXIST_PRIVATE_STORE:`${BASE_URL}/store/hasUserId`,//判断私有仓是否已存在
	CHECK_EXIST_CHILDREN_STORE:`${BASE_URL}/store/hasStoreName`,//判断子仓名是否已存在
	SET_SELLER_DISCOUNT:`${BASE_URL}/store/setSellerDiscount`,
	GET_SELLER_DISCOUNT:`${BASE_URL}/store/getSellerDiscount`,
	DELTE_SELLER_DISCOUNT:`${BASE_URL}/store/deleteSellerDiscount`,
	ADD_LEAGUE_STORE:`${BASE_URL}/store/addLeagueStore`,
	BIND_LEAGUE_STORE:`${BASE_URL}/store/bindLeagueStore`,
	UPDATE_BIND_STOREITEM_ADDITION:`${BASE_URL}/bindItem/updateBindStoreItemAddition`,
	ADD_NEW_STOREITEM_NOT_PRODUCT:`${BASE_URL}/item/addStoreItemNotProduct`,
	GET_SHOPIFY_URL:`${BASE_URL}/access/getShopFiyUrl`,
	BIND_SHOPIFY:`${BASE_URL}/access/bindShopFiyShop`,
	GET_PARTNER_ID:`${BASE_URL}/partner/partner/get`,
	GET_TIKTOK_SHOP_URL:`${BASE_URL}/access/getTiktokShopUrl`,
	GET_TIKTOK_SHOP_URL_EN:`${BASE_URL}/access/getTiktokUSShopUrlPublic`,
	GET_TIKTOK_SHOP_URL_CUSTOM:`${BASE_URL}/access/getTiktokUSShopUrlCustom`,
	MASS_PUSHBLISH_GOODS:`${BASE_URL}/item/tts/product/create/batch`,
	GET_STATUS_PUBLISH_TIKTOP:`${BASE_URL}/item/tiktok/product/process/get`,
	GET_LAZADA_PRODUCT_DETAIL:`http://192.168.1.41:8085/item/lazada/item/get`,
	GET_PURCHASE_SKUSINFO:`${BASE_URL}/item/purchase/batch`,
	GET_BANED_SELLERS:`${BASE_URL}/store/access/store/ban/list`,
	DEL_BANED_SELLERS:`${BASE_URL}/store/remove/seller/from/ban/list`,
	ADD_BANED_SELLERS:`${BASE_URL}/store/ban/seller`,
	CREATE_FBS_RULES:`${BASE_URL}/integration/createFbsRule`,
	GET_RULES_BY_COUNTRY:`${BASE_URL}/integration/getSellerFbsRule`,
	DELETE_RULES:`${BASE_URL}/integration/deleteFbsRule`,//删除扣费规则
	



	
}

const tiktok={
	GET_TIKTOK_BRAND: `${BASE_URL}/item/tts/brand`,
	GET_TIKTOK_ATTRIBUTE: `${BASE_URL}/item/tts/category/attribute`,
	GET_TIKTOK_CATEGORY: `${BASE_URL}/item/tts/category/get`,
	GET_TIKTOK_RULE_CATEGORY: `${BASE_URL}/item/tts/category/rule`,
	GET_TIKTOK_UPLOAD: `${BASE_URL}/item/tts/image/url/upload`,
	GET_TIKTOK_PRODUCT_CREATE: `${BASE_URL}/item/tts/product/create`,
	GET_TIKTOK_WAREHOUSE:`${BASE_URL}/item/tts/warehouse/get`,
	

}

const freeApplyOrder={
	FREEAPPLYORDER_APPLY: `${BASE_URL}/freeApplyOrder/apply`,
	FREEAPPLYORDER_AUDITORDERALL: `${BASE_URL}/freeApplyOrder/auditOrderAll`,
	FREEAPPLYORDER_AUDITUNPASSORDERALL: `${BASE_URL}/freeApplyOrder/auditUnPassOrderAll`,
	FREEAPPLYORDER_QUERYAPPLYORDERS: `${BASE_URL}/freeApplyOrder/queryApplyOrders`,
	FREEAPPLYORDER_GET: `${BASE_URL}/freeApplyOrder/getStoreItemByFreeIds`,
	FREEAPPLYORDER_CREAT: `${BASE_URL}/freeApplyOrder/createDxsFreeOrder`,
	FREEAPPLYORDER_UPLOAD: `${BASE_URL}/freeApplyOrder/upload/fileUrl`,
	FREEAPPLYORDER_RETURN: `${BASE_URL}/freeApplyOrder/auditRefuseReturn`,
	FREEAPPLYORDER_RETURNJF: `${BASE_URL}/freeApplyOrder/returnIntegral`,
}
const order={
	GET_ORDER_LIST: `${BASE_URL}/shopOrder/getOrders`,
	GET_ORDER_TOTAL: `${BASE_URL}/shopOrder/getOrderCountByUserId`,
	GET_ORDER_BY_TRICKNO:`${BASE_URL}/shopOrder/getOrdersByOrdersn`,
	GET_ORDER_BY_TRICKNO_RETURN:`${BASE_URL}/shopOrder/getReturnsByOrdersn`,
	GET_ORDER_TRICKNO:`${BASE_URL}/shopOrder/getTrackIngNoByOrdersn`,//订单号轮询查找运输号
	GET_ORDER_REVIEW:`${BASE_URL}/shopOrder/auditOrderAll`,
	PICK_OFF_ORDER:`${BASE_URL}/shopOrder/initOrderByPickup`,
	DROP_OFF_ORDER:`${BASE_URL}/shopOrder/initOrderByDroPoff`,
	PRINT_ORDER_BY_shopee:`${BASE_URL}/shopOrder/getOrderBillUrl`,
	GEI_ORDER_BY_USERID:`${BASE_URL}/shopOrder/getOrderByUserId`,
	UPDATE_SHOP_ORDER_ALL:`${BASE_URL}/shopOrder/updateShopOrdersAll`,
	VIEW_LOGISTICS:`${BASE_URL}/shopOrder/getTracking`,
	CANCEL_REVIEW_SHOPEE:`${BASE_URL}/shopOrder/cancelAuditedOrders`,
	RECIEVE_RETUREN_GOODS:`${BASE_URL}/shopOrder/receivedReturn`,
	SELLER_COMFIRM:`${BASE_URL}/shopOrder/sellerAudit`,
	STORE_COMFIRM:`${BASE_URL}/shopOrder/storeProcessed`,
	GET_AUTOAUDITORE_RULE:`${BASE_URL}/access/getAutoAuditRule`, //获取自动审核规则
	ADD_AUTOAUDITORE_RULE:`${BASE_URL}/access/addAutoAuditRule`,//增加自动审核规则
	DEL_AUTOAUDITORE_RULE:`${BASE_URL}/access/deleteAutoAuditRule`,//删除自动审核规则
	UPDATE_AUTOAUDITORE_RULE:`${BASE_URL}/access/updateAutoAuditRule`,//更新自动审核规则
	GET_GOODS_ORDER:`${BASE_URL}/shopOrder/getOrdersByItem`,//根据商品获取卖家订单
	GET_SPECIES_ORDER:`${BASE_URL}/shopOrder/getSellerOrdersItems`,//获取卖家订单商品种类数
	GET_LOGISTICS:`${BASE_URL}/shopOrder/getSellerOrdersLogistics`,//获取物流方式
	ADD_PRINT_TIMES:`${BASE_URL}/shopOrder/addPrintfTimes`,//增加打印次数
	GET_PROINT_SHEET_HISTORY:`${BASE_URL}/shopOrder/getOrderBillUrlList`,//获取打印面单历史纪录
	GET_PRINT_TOGETHER:`${BASE_URL}/shopOrder/margeOrderBill`,//获取打印面单历史纪录
	ADD_PACKAGE_ORDER:`${BASE_URL}/shopOrder/addOrderPackage`,//新增代打包运单号
	GET_ORDER_BY_PACKAGE_TRACKINGCODE:`${BASE_URL}/shopOrder/getOrderByPackageTrackingCode`,//根据打包运单号查询订单
	SOTRE_RECEIVED:`${BASE_URL}/shopOrder/storeReceived`,//仓库收到代打包运单
	DELTE_ORDER_PACKAGE:`${BASE_URL}/shopOrder/deleteOrderPackage`,//删除代打包的运单号
	GET_STORE_ITEM_BY_ID:`${BASE_URL}/item/getStoreItemByIds`,//获取仓库产品
	REVIVIEING_INFORMATION:`${BASE_URL}/integration/createLogisticsOrder`,//填写物流单号
	REGENERATE_PDF:`${BASE_URL}/shopOrder/resetBillUrl`,//重新生成URL地址
	GET_GOODS_TYPE:`${BASE_URL}/integration/getOrderDeductions`,//卖家获取积分预扣
	GET_GOODS_TYPE_STORE:`${BASE_URL}/integration/getOrderDeduction`,//仓库获取货物类型
	GET_UNAUDIT_ORDERS:'https://erp.shopsbu.com/query_data/order/getUnAuditOrders',//获取待审核的订单，高级页面
	RELOAD_ORDER:`${BASE_URL}/shopOrder/reloadOrder`, //重新加载订单
	QUERY_ORDERS:`${BASE_URL}/shopOrder/queryOrders`, //买家查询全部的订单
	UPDATA_CUSTOMER:`${BASE_URL}/shopOrder/updateCustom`, //更新为手工单 /shopOrder/
	UPDATA_MSG_TO_STORE:`${BASE_URL}/shopOrder/updateMsgToStore`,
	SENDMSG_REMIND:`${BASE_URL}/bulk-order/sendMsgToUserByBulkOrder`,
	GET_SHOP_ITEMS_BY_IDS:`${BASE_URL}/item/getShopItemsByIds`, 
	QUERY_ORDERS_NEW:`${BASE_URL}/query/queryOrders`, 
	QUERY_RETURN_ORDERS_NUM:`${BASE_URL}/query/queryReturnOrdersNum`, 
	QUERY_RETURN_ORDERS:`${BASE_URL}/query/queryReturnOrders`, 
	PAY_FBS_ORDER:`${BASE_URL}/integration/payFbsOrder`, 
	updata_INDEPENDENT:`${BASE_URL}/item/updateIndependent`, 
	UPDATE_SEPARATENUM:`${BASE_URL}/item/updateSeparateNum`, 
	SELLER_UPDATA_PURCHASEORDER:`${BASE_URL}/purchaseOrder/updatePurchaseOrder`, 
	HIDDEN_ORDER:`${BASE_URL}/shopOrder/hiddenOrder`, 
	UPDATA_PRODUCTID:`${BASE_URL}/item/updateProductId`, 
	GET_PRODUCT_ID:`${BASE_URL}/item/getProduct`, 
	COPY_STORE_ITEM:`${BASE_URL}/item/copyStoreItem`, 
	CHECK_PAY_AGENCYFEE:`${BASE_URL}/item/checkPayAgencyFee`, 
	UPDATA_SENSITIVE_TRUE:`${BASE_URL}/item/update/sensitive`, 
	FIEXED_USERINFO_SENITIVE:`${BASE_URL}/access/sensitive`, 
	DISTRIBUTE_ORDER:`${BASE_URL}/query/distribute/order`, 
	GET_INDUSTIAL_BELT:`${BASE_URL}/industrial/belt/select`,

	
	GET_OUTBOUND_TIME:`${BASE_URL}/shopOrder/getOutboundTime`, //根据订单号同步工厂出库状态

	
}

const item={
	UPDATE_ITEMS: `${BASE_URL}/item/updateShopItem`,
	GET_SHOP_ITEMS: `${BASE_URL}/item/getShopItems`,
	PRINT_PDF: `${BASE_URL}/purchaseOrder/getOrderPdf`,
	PRINT_ORDER_AND_PICKLIST:`${BASE_URL}/print/printPdf`,
	UPDATE_PRICE_BY_CUSCODE:`${BASE_URL}/item/updatePriceByCusCode`,
	UPDATE_USER_DISTRIBUTOR_LEVEL:`${BASE_URL}/access/updateUserDistributorLevel`,
	
}

const registor={
	GET_REGISTOR:`${BASE_URL}/access/register`,
	STORE_REMIND:`${BASE_URL}/shop/getShopStockRemind`,
	AUDITCH:`${BASE_URL}/purchaseOrder/sellerAudit`,
	AUDITOR_PURCHASE_ORDER:`${BASE_URL}/purchaseOrder/createCopy`,
	GET_SELLER_STORE:`${BASE_URL}/access/getSellerStore`,
	AUDIT_ALL_ORDER:`${BASE_URL}/query/canAuditOrder`,
	BIND_STORE:`${BASE_URL}/access/bindStore`,
	CREATE_PURCHASE_ORDER:`${BASE_URL}/purchaseOrder/create`,
	BIGN_ITEMS:`${BASE_URL}/bindItem/bind`,
	GET_PURCHASE_ORDER_BY_USER_ID:`${BASE_URL}/purchaseOrder/getByUserId`,
	GET_SHOP_VARIATIONS:`${BASE_URL}/item/getShopVariations`,
	CREATE_WAREHOUSE_BYSTORE:`${BASE_URL}/store/addPrivateStore`,
	SEARCH_WAREHOUSE:`${BASE_URL}/access/getSellerStore`,
}

const mygoods={
	GET_SHOP_ITEMS_TOTAL:`${BASE_URL}/item/getShopItemsCount`,
	ADD_SHOP_IN_STORE:`${BASE_URL}/item/addStoreItem`,
	GET_LAZADA_SHOP_ITEMS:`${BASE_URL}/item/lazada/getLazadaShopItems`,
	TONG_BU_LAZADA_ITEM:`${BASE_URL}/item/lazada/updateLazadaItem`,
	GET_ITEM_SALES:`${BASE_URL}/sales/getItemSales`,
	GET_INVENTORY_TURNOVER:`${BASE_URL}/sales/getInventoryTurnover`,
	GET_CATEGOR_BY_SHOP:`${BASE_URL}/item/getCategoryByShop`,
	BATCH_CREATE_STORE_ITEM:`${BASE_URL}/item/batchCreateStoreItem`,
	PRINT_PRODUCT_BAR_CODE:`${BASE_URL}/print/getBarCode`,
	GET_ONLIONE_GOODS:`${BASE_URL}/item/get`,
	GET_BIND_ITEM_INFO:`${BASE_URL}/bindItem/get`,
	GET_GROUNPID_INFO:`${BASE_URL}/item/getProductByGroupId`,
	UPDATA_ITEMSKUONLINE:`${BASE_URL}/item/updateItemSku`,
	UPDATA_CHILDREN_SKU:`${BASE_URL}/item/updateVariationSku`,
	REMOTE_PUCHCHASE_GODOWN:`${TEST_URL3}/purchase/order/bind`,
	UPDATE_STORE_RATE:`${BASE_URL}/item/update/times`,




	
	
}

//仓库商品
const getStoreItem={
	GET_STORE_ITEMS:`${BASE_URL}/item/getStoreItemAndGroup`,
	GET_STORE_ITEMS_STORE:`${BASE_URL}/item/getStoreItem`,
	GET_STORE_ITEM_COUNT:`${BASE_URL}/item/getStoreItemCount`,
	CREATE_CAIGUO_TABLE:`${BASE_URL}/purchaseOrder/create`,
	DELE_STORE_ITEMS:`${BASE_URL}/item/deleteStoreItem`,
	BIND_BY_SKU:`${BASE_URL}/bindItem/bindBySku`,
	JIE_BAN_ITEMS:`${BASE_URL}/bindItem/removeBind`,
	GET_PURCHASE_ORDER:`${BASE_URL}/purchaseOrder/getPurchaseOrder`,
	REMOVE_PURCHASE_ORDER:`${BASE_URL}/purchaseOrder/deletePurchaseOrder`,
	UPDATE_DATA_USER_STORE_ITEMS:`${BASE_URL}/item/updateStoreItemUnShipped`,
	UPDATA_SHOPEE_ITEM_STOCK:`${BASE_URL}/item/updateShopeeItemStock`,
	TONG_BU_SHOPEE_ITEM:`${BASE_URL}/item/updateShopItem`,
	SELLER_UPDATE_STORE_ITEM_DETAIL:`${BASE_URL}/item/buyerUpdateCost`,
	SELLER_UPDATE_SYNCHRONY:`${BASE_URL}/item/sellerUpdateSynchrony`,
	STORE_UPDATE_STORE_NUM_ADDRESS:`${BASE_URL}/item/storeUpdateStoreNumAndAddress`,
}

const userStoreItems={
	IS_AUTO_PRE:`${BASE_URL}/item/updateIsAutoPre`,
	GET_STOCK_REMIND:`${BASE_URL}/item/getStockRemind`,
	VIEW_STORE_SALSE_INFO:`${BASE_URL}/item/getStoreProductSales`,//获取仓库产品的销售情况 
	GET_STORE_SALSE_INFO:`${BASE_URL}/sales/getStoreSales`,//获取仓库的销售情况 
	GET_STOER_PRODUCT_INVENTORY_TURNOVER:`${BASE_URL}/sales/getStoreProductInventoryTurnover`,//获取仓库产品的库存周转率
	GET_IN_STOCK_OPERATE_RECORD:`${BASE_URL}/item/getStoreProductLog`,//获取仓库产品的库存日志
	FILE_UPLOAD:`${BASE_URL}/file/fileUpload`,//文件上传及解析
	UPDATA_RAGE:`${BASE_URL}/item/updateRate`,//修改倍率
	DELETE_GROUP:`${BASE_URL}/item/deleteGroup`,//删除组
	UPDATA_GROUP_NAME:`${BASE_URL}/item/updateGroupName`,//修改母sku
	UPDATE_BIND_STORE_ITEMS:`${BASE_URL}/bindItem/updateBindStoreItem`,//修改绑定库存产品
	UPDATA_IS_AUTO_PRE:`${BASE_URL}/item/updateIsAutoPre`,//更新是否开启自动预售
	SEARCH_CUSCODE:`${BASE_URL}/item/getStoreItemByCusCode`,//更新是否开启自动预售
	GET_AUTO_BIND_ITEMS:`${BASE_URL}/bindItem/getAutoBindItems`,//查看自动关联产品
	UPDATE_STORE_NUM_BY_STORE:`${BASE_URL}/item/updateStoreNum`,//仓储用户更新仓库商品的在仓库存
	GET_RULES_BY_STOREID:`${BASE_URL}/integration/getFbsRuleBySeller`,
	UPDATE_FBS_RULE:`${BASE_URL}/integration/updateFbsRule`,
	UPDATA_SHIPPED_DAYS:`${BASE_URL}/access/updateShipDay`,//更新运输天数
	UPDATA_STORE_IMAGE:`${BASE_URL}/bindItem/updateStoreItemImage`,//修改库存产品图片
	UPDATA_STORE_PARENT_IMAGE:`${BASE_URL}/bindItem/updateStoreItemGroupImage`,//修改母SKU产品图片
	GET_STORE_IETM_DEGREE:`http://47.57.9.89:8086/item/getStoreItemDegree`,//获取ABC数据
	GET_PURCHASEORDER_NUM:`${BASE_URL}/purchaseOrder/getPcOrderNum`,
	UPDATA_GROUP_INFO:`${BASE_URL}/item/updateGroup`,
	ADD_WHOLE_STOREITEM:`${BASE_URL}/item/addStoreItemGroupNotProduct`,
	DEDUCT_INTEGRATION:`https://adminbylgb.dianxiaosheng.com/service/integration/withdraw`,
	UPDATE_PUT_AWAY:`${BASE_URL}/item/updatePutAway`,
	GET_PUBLIC_STOREITEM:`${BASE_URL}/platform/group/get`,
	GET_CATEGORY_BY_STOREITEM:`${BASE_URL}/item/getCategoryByStoreItem`,
	COPY_STROE_ITEM:`${BASE_URL}/item/getCategoryByStoreItem`,
	TRANSFER_STORE_NUM:`${BASE_URL}/item/transferStoreNum`,
	UPDATE_ENCODING:`${BASE_URL}/item/updateEncoding`,
	GET_AGENTS_FROMGROUPID:`${BASE_URL}/platform/agency/group/items`,
	DELISTED_PRODUCTS:`${BASE_URL}/platform/annul/group`,
	UPDATE_PURCHASE_SHIPCOST:`${BASE_URL}/purchaseOrder/update/purchaseOrderPrice`,
	GET_SMSCODE_API:`${BASE_URL}/access/phone/code/login`,
	GET_SMSCODE_CODE_API:`${BASE_URL}/access/send/login/code`,
	CREATE_INQUIRY_ORDER_API:`${BASE_URL}/platform/create/inquiry/order`,
	GET_INQUIRY_ORDER_API:`${BASE_URL}/platform/query/inquiry/order`,
	GET_CATEGORY_API:`${BASE_URL}/platform/exist/category/get`,

	

	
}

const lazada={
	GET_ALLORDER_BY_USERID:`${BASE_URL}/shopOrder/lazada/getOrderByUserId`,
	ZAI_KUCHU_FANWEI_DADANG:`${BASE_URL}/shopOrder/lazada/auditLazadaOrdersByStockRule`,//在库存允许内审核多个订单
	GET_TYEP_LOGISTICS:`${BASE_URL}/shopOrder/lazada/getShipmentProviders`,
	GET_TRICKING_NO:`${BASE_URL}/shopOrder/startReadyOrders`,
	SYN_ORDERS:`${BASE_URL}/shopOrder/lazada/updateShopOrdersAll`,//同步lazada订单
	REVIEW_SOME_ORDER:`${BASE_URL}/shopOrder/lazada/auditLazadaOrders`,//库存允许范围内审核多个订单
	REVIEW_ALL_ORDER:`${BASE_URL}/shopOrder/lazada/auditLazadaOrders`,//不理库存情况下，全部审核选中的订单
	CANCEL_REVIEW:`${BASE_URL}/shopOrder/lazada/cancelAuditedLazadaOrders`,
	PRINT_ORDER:`${BASE_URL}/shopOrder/lazada/getShippingLabel`,
	LOOK_UP_ORDER:`${BASE_URL}/shopOrder/lazada/getOrderByAttribute`,
	
	GET_UNAUDIT_OREDER_LAZADA:`${BASE_URL_TWO}/lazada/getUnAuditOrders`,//卖家获取待审核订单
	GET_PROCESSED_OREDER_LAZADA:`${BASE_URL_TWO}/lazada/getOrders`,//卖家获取待处理订单

	
	
	
	
	

}
const recharge={
	CREATE_ORDER_PAYSSION:`${BASE_URL}/payssion/create/order`,//创建payssion支付订单
	CHECKED_ORDER_PAYSSION:`${BASE_URL}/payssion/check-order`,//payssion支付回调
	CREATE_ORDER_WECHAT:`${BASE_URL}/wechat-pay/create-order`,//创建微信支付订单
	CHECKED_ORDER_WECHAT:`${BASE_URL}/wechat-pay/check-order`,//检查支付结果
	CREATE_ORDER_ALIPAY:`${BASE_URL}/alipay/create-order`,//创建支付宝支付订单
	CHECKED_ORDER_ALIPAY:`${BASE_URL}/alipay/check-order`,//检查支付结果
	ORDER_TRACKING:`${BASE_URL}/order/findByParams`,//条件查询订单信息
	POINTS_CHANGE:`${BASE_URL}/order/findByTradeOrders`,//查询积分变更的信息
	REFRESH_POINT:`${BASE_URL}/integration/getUserIntegral`,//获取用户积分
	GET_EXCEPT_INTEGRAL:`${BASE_URL}/integration/getExceptIntegralLog`,//查看积分预扣详情
	GET_ORDER_DEDUCTION:`${BASE_URL}/integration/getOrderDeduction`,//查看订单预扣费数据
	GET_PAY_OPTIONS:`${BASE_URL}/access/getUserRechargeRule`,//获取充值规则
	
	
}

const printpage={
	GET_PARAMS:`${BASE_URL}/print/getParams`,//获取所有参数数据
	GET_ORDERS:`${BASE_URL_TWO}/order/getOrders`,//获取所有订单
	GET_ORDERS_ITEM:`${BASE_URL}/print/getOrderItems`,//获取订单商品
	ADD_PRINT_NUM:`${BASE_URL}/print/addPrintNum`,//增加打印次数
	ARR_RANGE_MENT:`${BASE_URL}/print/readyOrders`,//安排订单
	START_READY_ORDERS:`${BASE_URL}/print/startReadyOrders`,//开始准备订单数据,带参数
	SET_PACKAGED:`${BASE_URL}/print/setPackaged`,
	PRINT_MERGERORDERS:`https://erp.weanaly.com/erp/feign/print/printfMergerOrders`,
	GET_STORE_ORDER:`${BASE_URL_TWO}/order/getOrdersByStore`,
	GET_NEW_ORDERS:`${BASE_URL}/print/getNewOrders`,//点击开始生成运单号，再调此方法猎取最新的订单
	GET_LOGISTICS_INFO:`${BASE_URL}/print/getLogisticInfo`,//获取取件方式
	SET_ORDER_FLAG:`https://erp.weanaly.com/service/print/setOrderFlag`,//设置旗帜
	ADD_USER_FLAGE:`${BASE_URL}/access/addUserFlags`,//增加用户旗帜
	GET_USER_FLAGE:`${BASE_URL}/access/getUserFlags`,//获取用户旗帜
	UPDATA_USER_FLAG_DESC:`${BASE_URL}/access/updateUserFlagDesc`,//更新旗帜描述
	GET_ORDER_COUNT:`${BASE_URL_TWO}/order/getOrderCount`,//获取待审核的订单数量
	GET_FLAG_BY_ID:`${BASE_URL}/access/getFlagById`,//根据flagId获取旗帜信息
}

const dedution={
	GET_STOTRE_SELLER:`${BASE_URL}/access/getStoreSeller`,//获取仓库帐号绑定的所有卖家帐号
}


const customer={
	SENT_MESSAGE:`${BASE_URL}/chat/sendMsg`,//发送消息--内部会话	
	READ_MESSAGE:`${BASE_URL}/chat/readMsg`,//消息已读--内部会话
	GET_USER_MESSAGE:`${BASE_URL}/chat/getUserMsg`,//卖家获取消息--内部会话
	GET_SHOP_MESSAGE:`${BASE_URL}/message/shop/{shopId}`,//获取当前用户某个店铺近期消息列表--买家会话

	GET_ALLPURUSER:`${BASE_URL}/access/getPublicPurchaseUser`,//获取公共采购员账号

    GET_CART:`${BASE_URL}/item/shopping/cart/get`,//获取用户购物车中的商品

    ADD_CART:`${BASE_URL}/item/shopping/cart/add`,//从分销平台添加产品到购物车

    REMOVE_CART:`${BASE_URL}/item/shopping/cart/remove`,//从购物车中移除商品

    GET_GROUP_CART:`${BASE_URL}/item/shopping/cart/group/get`,//获取用户购物车中的商品,按group_id分组
    
    COPY_CART:`${BASE_URL}/item/copy`,//复制库存产品


    PAYMENT_ORDER:`${TEST_URL3}/purchase/order/balanceFinalPayment`,//
}


const operation = {
	GET_DISCOUNT_LIST: `${WEANALY_DOMAIN}/shopee_seller/get_discount_list`,
	ADD_DISCOUNT: `${WEANALY_DOMAIN}/shopee_seller/add_discount`,
	ADD_AUTO_DISCOUNT: `${WEANALY_DOMAIN}/shopee_seller/add_auto_discount`,
	MONITOR_AUTO_DISCOUNT: `${WEANALY_DOMAIN}/bei_erp/monitor_auto_discount`,
	GET_ACCOUNT_ITEMS: `${WEANALY_DOMAIN}/bei_erp/items/get`,
	MONITORING_GOODS: `${WEANALY_DOMAIN}/bei_erp/item/data`,
	BIND_ACCOUNT_ITEM_2_MODEL: `${WEANALY_DOMAIN}/bei_erp/items/bind`,
	GET_SHOP_MONITOR_INFO: `${WEANALY_DOMAIN}/bei_erp/items/shop`,
	GET_MONITOR_RULES: `${WEANALY_DOMAIN}/bei_erp/promotion`,
	UNBIND_MODEL_AND_ITEM: `${WEANALY_DOMAIN}/bei_erp/items/unbind`

}



// 新增内容
const remind={
	GET_SYSTEM_TEMPLATE:`${TEST_URL}/note/template/system`,//获取系统短信模板
	ADD_CUSTOM_MESSAGE_TEMPLATE:`${TEST_URL}/note/template/insert`,//增加自定义短信模板
	OPEN_NOTE_CHANNEL:`${TEST_URL}/openNoteChannel`,//短信提醒通道开关
	UPDATE_USER_SELECTION_TEMPLATE:`${TEST_URL}/note/template`,//更新当前用户选择模板
	GET_CUSTOM_TEMPLATE_LIST:`${TEST_URL}/note/template`,//获取自定义模板列表
	DELETE_CUSTOM_MESSAGE_TEMPLATE:`${TEST_URL}/note/template`,//删除自定义短信模板
	GET_NOTE_TEMPLATE_COUNT:`${TEST_URL}/note/template/count`,// 获取短信文本的计费条数和长度
	GET_NOTE_CHANNEL:`${TEST_URL}/channel/status`,// 查看店铺各个短信提醒通道的开关状态
	SEND_TEST_NOTE:`${TEST_URL}/note/template/test/send`,//发送短信测试
	GET_SHOP_CHOOSE_TEMPLATE:`${TEST_URL}/note/template/picked`,//获取店铺已选择模板
	GET_NOTE_RECORDS:`${TEST_URL}/note/records`,//获取店铺的短信记录
	GET_PAYMENT_STATISTIC:`${TEST_URL}/payment/statistic`,//获取催付提醒后用户支付订单时间分析
	GET_NOTE_RECORD_BY:`${TEST_URL}/note/record/filer`,//通过过滤条件获取短信记录
	SET_COD_SWITCH:`${TEST_URL}/cod/switch`,//设置发货提醒是否提醒COD订单
	GET_COD_SWITCH:`${TEST_URL}/get/cod`,//获取COD开关状态
	GET_REMIND_SEND_COUNT:`${TEST_URL}/note/record/statistic`,//获取短信发送数量的统计
	GET_SUCCESS_PAY_COUNR:`${TEST_URL}/note/payment/success/statistic`,//获取催付提醒成功支付订单数统计


	GET_BUYER_ANALYSIS:`${TEST_URL}/portrait/buyerUser/analysis`,//获取用户画像
	GET_BUYER_ORDERS:`${TEST_URL}/portrait/buyerUser/orders`,//获取用户画像
	GET_USER_CATEGORY:`${TEST_URL}/portrait/category`,//获取用户画像分类
	GET_USER_CATEGORY_ALL_BUYER:`${TEST_URL}/portrait/category/buyerUser`,//获取某个用户下某个分类的所有买家


	GET_CUSTOM_GROUP:`${TEST_URL}/obtain/category`,//获取用户的自定义分组
	GET_CUSTOM_GROUP_USER:`${TEST_URL}/category/obtain/consumer`,//获取用户的自定义分组
	CREATE_CATEGORY:`${TEST_URL}/create/category`,//创建自定义分组
	DELETE_CATEGORY:`${TEST_URL}/delete/category`,//删除自定义分组
	UPDATE_CATEGORY:`${TEST_URL}/update/category`,//修改自定义分组
	INSERT_CONSUMER:`${TEST_URL}/category/insert/consumer`,//向某个分组添加买家
	SHARE_CONSUMER:`${TEST_URL}/category/consumer/share`,//将某个买家在所属分组共享，一般用在黑名单
	DELETE_CONSUMER:`${TEST_URL}/category/delete/consumer`,//将某个买家从自定义分类中移除
	GET_TUSERGROUP:`${TEST_URL}/categories/userId/consumerName`,//将某个买家从自定义分类中移除

	SYNC_SHOPMESSAGE:`${TEST_URL2}/message/sync/conversation`,//一键同步shopee会话
	GET_AUTH:`${TEST_URL2}/shop/v1/auth/status`,//查看某个店铺是否授权shopee v1版本
	GET_USERAUTO:`${TEST_URL2}/user/auto/replay/update`,//更新某个用户的自定义回复
	GET_USERREPLAY:`${TEST_URL2}/user/auto/replay/access`,//获取某个用户的自定义自动回复
	GET_INTEGRAL:`${TEST_URL2}/integral/access`,//获取智能客服翻译收费规则
	INSERT_INTEGRAL:`${TEST_URL2}/integral/insert`,//添加智能客服翻译收费规则
	DELETE_INTEGRAL:`${TEST_URL2}/integral/delete`,//删除智能客服翻译收费规则
	UPDATE_INTEGRAL:`${TEST_URL2}/integral/update`,//更新智能客服翻译收费规则

	GET_VAILDINFO:`${TEST_URL}/portrait/validDataInfo`,//获取数据

    GET_INFO_USER:`${TEST_URL}/portrait/showProgress`,//显示进程(有数据正在计算才会返回进程)

    GET_CALCULAT:`${TEST_URL}/portrait/calculateIndicators`,//发送请求即计算指标
	

    DEDUCT_USER:`https://adminbylgb.dianxiaosheng.com/service/integration/withdraw`,//扣除积分

	
}

const chat = {
	ADD_REMARK:`${TEST_URL2}/message/add/ordernote`,//添加备注
	CANCEL_ORDE:`${TEST_URL2}/message/cancel/order`,//取消订单
	GET_MESSAGE_HISTORY:`${TEST_URL2}/message/history/conversation/message`,//获取某个对话的历史记录
	TRANSLATION:`${TEST_URL2}/message/textTranslate`,//文本翻译
	SEND_MESSAGE:`${TEST_URL2}/message/insertMessage`,//发消息
	GET_RECENT_MESSAGE_LIST:`${TEST_URL2}/message/shop/conversation`,//获取当前用户某个店铺近期消息列表
	// GET_RESEND_MESSAGE:`${TEST_URL2}/message/textTranslate`,//获取转交给当前用户的消息
	GET_UNREAD_CONVERSATION:`${TEST_URL2}/message/unread/conversation`,//获取所有未读消息数
	UPLOAD_IMAGE:`${TEST_URL2}/message/upload`,//上传图片 
	PINNED:`${TEST_URL2}/message/update/pinned`,//Pinned 
	READ_CONVERSATION:`${TEST_URL2}/message/read/conversation`,//标记会话已读
	DELETE_CONVERSATION:`${TEST_URL2}/message/delete/conversation`,//删除一个会话
	GET_CONSERVATION_ALL_HISTORY:`${TEST_URL2}/message/history/conversation/message/all`,//获取某个会话的所有记录

	// 问答管理
	GET_TREE:`${TEST_URL2}/category/tree`,//获取目录树
	ADD_TREE:`${TEST_URL2}/category/insert`,//添加目录树
	ADD_KNOWLEDGE:`${TEST_URL2}/knowledge`,//添加一条知识
	
	GET_KNOWLEDGE:`${TEST_URL2}/knowledge`,//获取某个目录下的所有知识
	DEL_KNOWLEDGE:`${TEST_URL2}/knowledge`,// 删除某个知识
	UPDATE_KNOWLEDGE:`${TEST_URL2}/knowledge`,// 修改某个知识
	SEARCH_KNOWLEDGE:`${TEST_URL2}/knowledge/search/knowledge`,// 搜索某个知识
	MATCH_KNOWLEDGE:`${TEST_URL2}/knowledge/question/match`,// 搜索命中的知识



	DELETE_SHORTCUT_GROUP:`${TEST_URL2}/shortcut/delete/group`,//删除分组
	DELETE_SHORTCUT_MESSAGE:`${TEST_URL2}/shortcut/delete/message`,//删除分组中的短语
	UPDATE_SHORTCUT_MESSAGE:`${TEST_URL2}/shortcut/update/message`,//更新分组中的短语
	UPDATE_SHORTCUT_GROUP:`${TEST_URL2}/shortcut/update/group`,//更新分组名称



	GET_SHORTCUT_LIST_GROUP:`${TEST_URL2}/shortcut/list/group`,//获取分组列表
	GET_SHORTCUT_LIST_MESSAGE:`${TEST_URL2}/shortcut/list/message`,//获取某个分组下的所有快捷短语
	ADD_SHORTCUT_MESSAGE:`${TEST_URL2}/shortcut/insert/message` ,//添加某个分组下的快捷短语
	ADD_SHORTCUT_GROUP:`${TEST_URL2}/shortcut/insert/group`,//添加分组




	SEARCH_MESSAGE:`${TEST_URL2}/message/search`,
	GET_BUYER_ORDER:`${TEST_URL2}/message/recent/orders`,
	


	GET_SHORTCUT_LIST_GROUP:`${TEST_URL2}/shortcut/list/group`,//获取分组列表
	GET_SHORTCUT_LIST_MESSAGE:`${TEST_URL2}/shortcut/list/message`,//获取某个分组下的所有快捷短语
	ADD_SHORTCUT_MESSAGE:`${TEST_URL2}/shortcut/insert/message` ,//添加某个分组下的快捷短语
	ADD_SHORTCUT_GROUP:`${TEST_URL2}/shortcut/insert/group`,//添加分组




	SEARCH_MESSAGE:`${TEST_URL2}/message/search`,
	GET_BUYER_ORDER:`${TEST_URL2}/message/recent/orders`,
	


	DELETE_SHORTCUT_GROUP:`${TEST_URL2}/shortcut/delete/group`,//删除分组
	DELETE_SHORTCUT_MESSAGE:`${TEST_URL2}/shortcut/delete/message`,//删除分组中的短语
	UPDATE_SHORTCUT_MESSAGE:`${TEST_URL2}/shortcut/update/message`,//更新分组中的短语
	UPDATE_SHORTCUT_GROUP:`${TEST_URL2}/shortcut/update/group`,//更新分组名称



	GET_SHORTCUT_LIST_GROUP:`${TEST_URL2}/shortcut/list/group`,//获取分组列表
	GET_SHORTCUT_LIST_MESSAGE:`${TEST_URL2}/shortcut/list/message`,//获取某个分组下的所有快捷短语
	ADD_SHORTCUT_MESSAGE:`${TEST_URL2}/shortcut/insert/message` ,//添加某个分组下的快捷短语
	ADD_SHORTCUT_GROUP:`${TEST_URL2}/shortcut/insert/group`,//添加分组




	SEARCH_MESSAGE:`${TEST_URL2}/message/search`,
	GET_BUYER_ORDER:`${TEST_URL2}/message/recent/orders`,
	



	// RESEND_MESSAGE:`${TEST_URL2}/message/turnOverMessage`,//将一个对话转交给指定用户

	GET_AUTHORIZED_SHOPS:`${TEST_URL2}/access/authorized/shop`,//获取已授权的店铺
	GET_AUTHORIZATION_URL:`${TEST_URL2}/authorize/url/get`,//
	CANCEL_AUTHORIZE:`${TEST_URL2}/cancel/authorize`,
	GET_CANCEL_AUTHORIZE_URL:`${TEST_URL2}/cancel/authorize/url/get`,
	GET_ACCESS_TOKEN:`${TEST_URL2}/cancel/authorize/url/get`,

	GET_SHOP_AUTOMATIC:`${TEST_URL2}/access/shop/automatic/translate`,//获取店铺自动翻译设置
	UPDATE_SHOP_AUTOMATIC:`${TEST_URL2}/update/shop/automatic/translate`,//更新店铺自动翻译设置
	GET_ANSWER:`${TEST_URL2}/knowledge/answer/recommend`,//获取回答推荐

	ANSWER_BEHAVIOR:`${TEST_URL2}/collect/answer/behavior`,//记录客服消息发送记录

	SET_ANTOMATIC:`${TEST_URL2}/set/automatic/reply/setting`,//更新店铺的自动回复日期设置
	GET_ANTOMATIC:`${TEST_URL2}/get/automatic/reply/setting`,//获取店铺的自动回复

	GET_QUESTION:`${TEST_URL2}/knowledge/question/recommend`,//获取推荐的问题
	FREQUENT_QUESTION:`${TEST_URL2}/knowledge/access/most/frequent/question`,//获取推荐的问题

	CREATE_CONVER:`${TEST_URL3}/conversation/create/conversation`,//创建会话
	MESSAGE_INSERT:`${TEST_URL3}/message/insert`,//发送一条消息
	MESSAGE_CONVER:`${TEST_URL3}/message/conversation`,//获取会话的历史消息
	CONVER_LIST:`${TEST_URL3}/conversation/list`,//获取用户的会话列表
	MARK_READ:`${TEST_URL3}/conversation/mark/as/read`,//标记会话为已读
	MESSAGE_ASREAD:`${TEST_URL3}/message/mark/as/read`,//标记消息为已读
	DELETE_CONVER:`${TEST_URL3}/conversation/delete/conversation`,//删除一个会话

	UNREAD_COUNT:`${TEST_URL3}/conversation/total/unread/count`,//获取用户的所有未读消息数

	GET_PURCHASE:`${TEST_URL3}/purchase/order/list`,//获取采购单列表
	CREATE_SUP:`${TEST_URL3}/product/supplier/create`,//创建供应商

	GET_SUPLIST:`${TEST_URL3}/product/supplier/list`,//获取供应商列表
	DELETE_SUP:`${TEST_URL3}/product/supplier/delete`,//删除供应商
	UPDATE_SUP:`${TEST_URL3}/product/supplier/update`,//更新供应商详情
	GET_SUPDETAILS:`${TEST_URL3}/product/supplier/details`,//获取供应商详情

	CREATE_PUR:`${TEST_URL3}/purchase/order/create`,//创建采购单
	GET_PURDETIL:`${TEST_URL3}/purchase/order/detail`,//获取采购单详情
	AUDIT_PURCHSEE:`${TEST_URL3}/purchase/order/audit`,//审核采购单
	DELETE_PUROR:`${TEST_URL3}/purchase/order/remove`,//删除采购单
	UPDATE_PUROR:`${TEST_URL3}/purchase/order/update`,//更新采购单
	UPDATE_PURORSTATUS:`${TEST_URL3}/purchase/order/update/status`,//更新采购单
	ORDER_LIST_DE:`${TEST_URL3}/purchase/order/list/detail`,//获取采购单列表详情

	GET_USERHOUSE:`${TEST_URL3}/product/warehouse/access`,//根据用户ID获取仓库
	CREATE_WAREHOUSE:`${TEST_URL3}/product/warehouse/create`,//创建仓库
	DELETE_WAREHOUSE:`${TEST_URL3}/product/warehouse/delete`,//删除仓库信息
	UPDATE_WAREHOUSE:`${TEST_URL3}/product/warehouse/update`,//采购单状态更新

	GET_COMMENT:`${TEST_URL3}/purchase/order/comment/access`,//获取某个采购单的评论
	CREATE_COMMENT:`${TEST_URL3}/purchase/order/comment/create`,//给采购单添加评论

	SET_LEADER:`${TEST_URL4}/access/setBuyerLeader`,//更改采购小组组长

	CREATE_ATTRIBUTE:`${TEST_URL3}/product/purchase/order/attribute/update`,
	GET_ATTRIBUTE:`${TEST_URL3}/product/purchase/order/attribute/access`,//获取采购单的自建属性
	
	GET_PRODUCTS:`${TEST_URL3}/product/library/access`,//获取产品列表
	GET_PRO_DETAIL:`${TEST_URL3}/product/library/detail`,//获取产品详情
	SEARCH_PRODUCT:`${TEST_URL3}/product/library/search`,//搜索产品
	CREATE_PRODUCT:`${TEST_URL3}/product/library/create`,//创建产品
	AUDIT_PRODUCT:`${TEST_URL3}/product/library/audit`,//更改产品的状态
	DELETE_PRODUCR:`${TEST_URL3}/product/library/delete`,//删除产品
	GET_AUDIT_ORDER:`${TEST_URL3}/product/purchase/order/audit/access`,//获取采购单状态变更历史
	UPDATE_PRODUCTS:`${TEST_URL3}/product/library/update`,//更新产品

	audit_update:`${TEST_URL3}/product/purchase/order/audit/update`,//修改采购单状态变更备注
    
    SEARCH_ORDER:`${TEST_URL3}/purchase/order/search`,//搜索采购单
    
    SEARCH_COMBINE:`${TEST_URL3}/purchase/order/search/combine`,//搜索采购单(不区分搜索条件）
	
}


const temu = {
	TEMU_SAVETEMUAUTHINFO:`${BASE_URL}/temu/auth/saveTemuAuthInfo`,   //新增temu平台token
	TEMU_GETTEMUAUTHINFO:`${BASE_URL}/temu/auth/getTemuAuthInfo`,   //获取temu平台token
	TEMU_UPDATETEMUAUTHINFO:`${BASE_URL}/temu/auth/updateTemuAuthInfo`,   //更新temu平台token
	TEMU_GETTEMUUSERINFO:`${BASE_URL}/access/getUserInfo`,   //获取temu权限列表
	TEMU_DELETETEMUAUTH:`${BASE_URL}/temu/auth/deleteTemuAuth`,   //删除temu平台权限
}

const gallery = {
	PATTERN_PATTERNPAGE:`${BASE_URL}/pattern/patternPage`,   //获取版面列表
	PATTERN_SAVEPATTERN:`${BASE_URL}/pattern/savePattern`,   //新增版面信息
	PATTERN_EDITPATTERN:`${BASE_URL}/pattern/editPattern`,   //修改版面信息
	PATTERN_GETPATTERNEDTAIL:`${BASE_URL}/pattern/getPatterneDtail`,   //根据id获取版面详情
	PATTERN_PATTERNBADPAGE:`${BASE_URL}/pattern/patternBadPage`,   //订单绑定版面列表
	PATTERN_BINDPATTER:`${BASE_URL}/shopOrder/bindPatter`,   //绑定版面
	PATTERN_UPDATECUSTOMIZEDTXT:`${BASE_URL}/shopOrder/updateCustomizedTxt`,   //更新定制文本
	PATTERN_DELETEPATTERN:`${BASE_URL}/pattern/deletePattern`,   //批量删除图版
	PATTERN_STARTREADYORDERS:`${BASE_URL}/shopOrder/startReadyOrders`,   //生成面单TEMU
	SHOPORDER_SELECTALLTEMUSHOP:`${BASE_URL}/shopOrder/selectAllTemuShop`,   //获取该用户TEMU平台店铺
	SHOPORDER_GETCATS:`${BASE_URL}/shopOrder/getCats`,   //查询货品类目
	SHOPORDER_GETATTRS:`${BASE_URL}/shopOrder/getAttrs`,   //按类目查询货品属性
	SHOPORDER_GETLOGISTICSTEMPLATE:`${BASE_URL}/shopOrder/getLogisticsTemplate`,   //物流模版查询接口
	SHOPORDER_GETPARENTSPEC:`${BASE_URL}/shopOrder/getParentSpec`,   //查询父规格列表
	SHOPORDER_CREATESPEC:`${BASE_URL}/shopOrder/createSpec`,   //生成规格
	SHOPORDER_GETSIZECHARTS:`${BASE_URL}/shopOrder/getSizecharts`,   //查询尺码表模板
	SHOPORDER_CREATESIZECHARTSTEMPLATE:`${BASE_URL}/shopOrder/createSizechartsTemplate`,   //生成尺码表模板
	SHOPORDER_GETSIZECHARTSCLASS:`${BASE_URL}/shopOrder/getSizechartsClass`,   //查询类目对应尺码表分类
	SHOPORDER_GETSIZECHARTSSETTINGS:`${BASE_URL}/shopOrder/getSizechartsSettings`,   //查询尺码模板规则
	SHOPORDER_GETSIZECHARTSMETA:`${BASE_URL}/shopOrder/getSizeChartsMeta`,   //尺码表元信息查询
	SHOPORDER_CREATESIZECHARTS:`${BASE_URL}/shopOrder/createSizecharts`,   //新增尺码表接口
	SHOPORDER_GETWAREHOUSELIST:`${BASE_URL}/shopOrder/getWarehouseList`,   //根据站点查询可绑定的发货仓库信息接口
	SHOPORDER_UPLOADGOODSIMAGE:`${BASE_URL}/shopOrder/uploadGoodsImage`,   //上传货品图片
	SHOPORDER_ADDGOODS:`${BASE_URL}/shopOrder/addGoods`,   //上传货品
	SHOPORDER_BATCHADDGOODS:`${BASE_URL}/shopOrder/batchAddGoods`,   //批量上传货品
	PATTERN_ADDSTANDARDPATTERNPRINTGROUPS:`${BASE_URL}/pattern/addStandardPatternPrintGroups`,   //新增标品图库分组
	PATTERN_ADDSTANDARDPATTERN:`${BASE_URL}/pattern/addStandardPattern`,   //新增标品图库
	PATTERN_STANDARDPATTERNPAGE:`${BASE_URL}/pattern/standardPatternPage`,   //获取标品图库版面列表
	PATTERN_PUBLISHPLATFORMHEAT:`${BASE_URL}/pattern/publishPlatformHeat`,   //获取标品图库版面列表
	SHOPORDER_UPLOADPINTIMAGE:`${BASE_URL}/shopOrder/uploadPintImage`,   //上传工厂打印图片
	PATTERN_ORDERBINDPRINTIMAGE:`${BASE_URL}/pattern/orderBindPrintImage`,   //订单关联标品图库图片
	PATTERN_GETSTANDARDPATTERNPRINTGROUPSLIST:`${BASE_URL}/pattern/getStandardPatternPrintGroupsList`,   //获取标品图库分组列表
	PATTERN_GETSTANDARDPATTERNDETAIL:`${BASE_URL}/pattern/getStandardPatternDetail`,   //根据id获取标品图库详情
	PATTERN_EDITSTANDARDPATTERN:`${BASE_URL}/pattern/editStandardPattern`,   //编辑标品版面信息
	PATTERN_DELETESTANDARDPATTERNPRINTGROUPS:`${BASE_URL}/pattern/deleteStandardPatternPrintGroups`,   //根据ID删除标品图库分组
	PATTERN_DELETESTANDARDPATTERN:`${BASE_URL}/pattern/deleteStandardPattern`,   //批量删除标品图库
	ADDSTOREITEMNOTPRODUCTUPDATEPARENTS:`${BASE_URL}/item/addStoreItemNotProductUpdateParents`,   //添加单个仓库物品信息并更新到所有代理商
	SHOPORDER_GETPROGRESS:`${BASE_URL}/shopOrder/getProgress`,   //批量上传记录列表
	SHOPORDER_STOPORDELETETASK:`${BASE_URL}/shopOrder/stopOrDeleteTask`,   //停止或删除批量上传任务

	SHOPORDER_UPDATEORDERITEMIMAGE:`${BASE_URL}/shopOrder/updateOrderItemImage`,   //更换子订单主图
}



const config = {
  ...shopaccess,
  ...login,
  ...order,
  ...registor,
  ...item,
  ...mygoods,
  ...getStoreItem,
  ...lazada,
  ...userStoreItems,
  ...recharge,
  ...printpage,
  ...processed,
  ...dedution,
  ...group,
  ...customer,
  ...remind,
  ...operation,
  ...chat,
  ...productModel,
  ...queryOrders,
  ...transfer,
  ...account,
  ...distribution,
  ...storeAffi,
  ...publishLazada,
  ...tiktok,
  ...freeApplyOrder,
  ...temu,
  ...gallery
}

export default config
